module.exports = __webpack_public_path__ + "static/img/glyphicons-halflings-regular.8988968.svg";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/glyphicons-halflings-regular.svg
// module id = breY
// module chunks = 1